module.exports = __webpack_public_path__ + "48b79305.png";